import i from './document-submission.container';

export default i;
